module.exports = __webpack_public_path__ + "img/slide2.3578c1f7.png";